import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { injectAxnAdminUserInvitationId } from "@utils/parameter-injector";
import { AxnAdminUserInvitation, FormattedAxnAdminUserInvitation } from "@idw-types/data/axn-admin-user-invitation";
import { RpUserPropertyBundle } from "@idw-types/data/axn-admin-user/rp-user-property-bundle";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type UpdateAxnAdminUserInvitationRequestResponse = {
    transferObject: AxnAdminUserInvitation;
};

export const updateAxnAdminUserInvitationRequest = async (
    axnAdminUserInvitation: FormattedAxnAdminUserInvitation
): Promise<GenericNetworkResponse<UpdateAxnAdminUserInvitationRequestResponse>> => {
    const route = injectAxnAdminUserInvitationId(
        apiRoutes.axnadminCore.axnadmin.invitationWithId,
        axnAdminUserInvitation.id
    );

    const relyingPartyRoles: Array<RpUserPropertyBundle> = [];

    if (axnAdminUserInvitation.relyingPartyRoles.length > 0) {
        axnAdminUserInvitation.relyingPartyRoles.forEach(bundle => {
            const bundleIdNumber = parseInt(bundle.bundle.id);
            const relyingPartyIdNumber = parseInt(bundle.relyingParty.id);

            relyingPartyRoles.push({
                relyingPartyID: relyingPartyIdNumber,
                userPropertyBundleID: bundleIdNumber
            });
        });
    }

    const userPropertyBundleID = relyingPartyRoles.length === 0
        ? (axnAdminUserInvitation.organizationRole?.id || null)
        : null;

    const body = {
        organizationID: axnAdminUserInvitation.organization?.id,
        status: axnAdminUserInvitation.status,
        userPropertyBundleID: relyingPartyRoles.length > 0 ? null : userPropertyBundleID,
        rpUserPropertyBundles: relyingPartyRoles.length > 0 ? relyingPartyRoles : null
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};